import { cookie } from '@otto-ec/global-resources/cookie'
import { HasConsentBeenGivenPort } from '../ports'

export const hasConsentBeenGiven: HasConsentBeenGivenPort = () =>
  cookie.exists('OptanonAlertBoxClosed')
